import { createMixins } from './mixins'
import { themeBase } from './themeBase'

// Create mixins with the base theme
const mixins = createMixins(themeBase)

// Export the complete theme with mixins
export const theme = {
    ...themeBase,
    mixins, // to be removed later
} as const

export type AppTheme = typeof theme
